module.exports = __webpack_public_path__ + "static/img/peopleGame3.a438680.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/video/peopleGame3.png
// module id = k2T9
// module chunks = 3